/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusStandortBerichtListResponseDto } from '../../models/lexplus-standort-bericht-list-response-dto';

export interface StandortBerichtControllerFindAllPaginatedV1$Params {

/**
 * Page number to retrieve. If you provide invalid value the default page number will applied
 *
 * **Example:** 1
 *
 *
 * **Default Value:** 1
 */
  page?: number;

/**
 * Number of records per page.
 *
 *
 * **Example:** 20
 *
 *
 *
 * **Default Value:** 25
 *
 *
 *
 * **Max Value:** 100
 *
 *
 * If provided value is greater than max value, max value will be applied.
 */
  limit?: number;

/**
 * Filter by standortID query param.
 *
 * **Format:** filter.standortID={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.standortID=$eq:John Doe&filter.standortID=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.standortID'?: Array<string>;

/**
 * Filter by erstelltAm query param.
 *
 * **Format:** filter.erstelltAm={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.erstelltAm=$btw:John Doe&filter.erstelltAm=$gte:John Doe
 *
 * **Available Operations**
 * - $gte
 *
 * - $lte
 *
 * - $btw
 *
 * - $and
 *
 * - $or
 */
  'filter.erstelltAm'?: Array<string>;

/**
 * Filter by upload.uploadDokumentSubTypID query param.
 *
 * **Format:** filter.upload.uploadDokumentSubTypID={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.upload.uploadDokumentSubTypID=$eq:John Doe&filter.upload.uploadDokumentSubTypID=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.upload.uploadDokumentSubTypID'?: Array<string>;

/**
 * Parameter to sort by.
 * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
 *
 * **Format:** {fieldName}:{DIRECTION}
 *
 *
 * **Example:** sortBy=erstelltAm:DESC&sortBy=iD:DESC
 *
 *
 * **Default Value:** erstelltAm:DESC
 *
 * **Available Fields**
 * - erstelltAm
 *
 * - iD
 *
 * - standortID
 */
  sortBy?: Array<'erstelltAm:ASC' | 'erstelltAm:DESC' | 'iD:ASC' | 'iD:DESC' | 'standortID:ASC' | 'standortID:DESC'>;

/**
 * Search term to filter result values
 *
 * **Example:** John
 *
 *
 * **Default Value:** No default value
 */
  search?: string;

/**
 * List of fields to search by term to filter result values
 *
 * **Example:** 
 *
 *
 * **Default Value:** By default all fields mentioned below will be used to search by term
 *
 * **Available Fields**
 */
  searchBy?: Array<string>;

/**
 * List of fields to select.
 *
 * **Example:** iD,standortID,erstelltAm,uebersetzung,standort.standortID
 *
 *
 * **Default Value:** By default all fields returns. If you want to select only some fields, provide them in query param
 */
  select?: string;
}

export function standortBerichtControllerFindAllPaginatedV1(http: HttpClient, rootUrl: string, params?: StandortBerichtControllerFindAllPaginatedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusStandortBerichtListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, standortBerichtControllerFindAllPaginatedV1.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.standortID', params['filter.standortID'], {});
    rb.query('filter.erstelltAm', params['filter.erstelltAm'], {});
    rb.query('filter.upload.uploadDokumentSubTypID', params['filter.upload.uploadDokumentSubTypID'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
    rb.query('select', params.select, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusStandortBerichtListResponseDto>;
    })
  );
}

standortBerichtControllerFindAllPaginatedV1.PATH = '/v1/standort-bericht/paginated';
